import React from 'react';
import {
  MetricTypeKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../../utils/types';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { setSignificanceMetricType } from '../../../../../redux/slices/oldBuilder';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';

const SignificanceMetricType = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === QueryType.Significance &&
      selectedOptions?.type === QueryType.Significance,
  );

  const { metrics } = defaultOptions;
  const { metric } = selectedOptions;

  const handleChange = (newType: MetricTypeKey) => {
    dispatch(setSignificanceMetricType({ newType }));
  };

  return (
    <BuilderEnumSelect
      label={'Metric will be based off'}
      enumOptions={metrics}
      selectedOption={metric}
      onChange={handleChange}
    />
  );
};

export default SignificanceMetricType;
